import { setup, setupCache, serializeQuery } from './api'
import RedisStore from './redis'
import RedisDefaultStore from './redis-default'

export { setup, setupCache, serializeQuery, RedisStore, RedisDefaultStore }
export default { setup, setupCache, serializeQuery, RedisStore, RedisDefaultStore }
